import React from 'react';
import ToolManagmentCard from '../../../../../../../common/element/Card/ToolManagmnetCard';

const NoteDocument = ({ companyData }) => {
  console.log(companyData, "companyDatacompanyDatacompanyData");

  // Function to get file icon based on file extension
  const getFileIcon = (url) => {
    const ext = url?.toLowerCase() || '';

    const isImage = ['.png', '.jpg', '.jpeg', '.gif'].some(e => ext.includes(e));
    const isPdf = ext.includes('.pdf');

    // IMAGE ICON (PNG/JPG)
    if (isImage) {
      return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path
            d="M9.46602 12.666H3.28693C2.88305 12.666 2.68111 12.666 2.5876 12.5862C2.50647 12.5169 2.46341 12.4129 2.47178 12.3065C2.48143 12.1839 2.62422 12.0411 2.90981 11.7556L8.57844 6.08693C8.84244 5.82292 8.97445 5.69091 9.12667 5.64145C9.26057 5.59795 9.4048 5.59795 9.53869 5.64145C9.69091 5.69091 9.82292 5.82292 10.0869 6.08693L12.666 8.66602V9.46602M9.46602 12.666C10.5861 12.666 11.1462 12.666 11.574 12.448C11.9503 12.2563 12.2563 11.9503 12.448 11.574C12.666 11.1462 12.666 10.5861 12.666 9.46602M9.46602 12.666H3.86602C2.74591 12.666 2.18586 12.666 1.75803 12.448C1.38171 12.2563 1.07575 11.9503 0.884003 11.574C0.666016 11.1462 0.666016 10.5861 0.666016 9.46602V3.86602C0.666016 2.74591 0.666016 2.18586 0.884003 1.75803C1.07575 1.38171 1.38171 1.07575 1.75803 0.884003C2.18586 0.666016 2.74591 0.666016 3.86602 0.666016H9.46602C10.5861 0.666016 11.1462 0.666016 11.574 0.884003C11.9503 1.07575 12.2563 1.38171 12.448 1.75803C12.666 2.18586 12.666 2.74591 12.666 3.86602V9.46602M5.66602 4.33268C5.66602 5.06906 5.06906 5.66602 4.33268 5.66602C3.5963 5.66602 2.99935 5.06906 2.99935 4.33268C2.99935 3.5963 3.5963 2.99935 4.33268 2.99935C5.06906 2.99935 5.66602 3.5963 5.66602 4.33268Z"
            stroke="white"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    }

    // PDF ICON
    if (isPdf) {
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.6424 10.2861C11.4593 10.34 11.1905 10.3461 10.9023 10.3044C10.593 10.2596 10.2775 10.1652 9.96737 10.0261C10.5204 9.9458 10.9494 9.97055 11.3163 10.1003C11.4032 10.1311 11.546 10.2133 11.6424 10.2861ZM8.55703 9.77971C8.53453 9.78582 8.51237 9.7916 8.49032 9.79771C8.34152 9.83814 8.19675 9.87759 8.05723 9.91269L7.8691 9.96031C7.49068 10.0559 7.10376 10.1536 6.72161 10.2698C6.86684 9.92023 7.00177 9.56675 7.13388 9.22115C7.2317 8.96532 7.33159 8.70399 7.43489 8.44602C7.4873 8.53242 7.54199 8.61886 7.5989 8.70552C7.85817 9.09972 8.18409 9.46419 8.55703 9.77971ZM7.59443 5.83722C7.61896 6.26863 7.52572 6.68364 7.38895 7.08177C7.22047 6.58947 7.14196 6.04584 7.35259 5.60694C7.40661 5.49444 7.45086 5.43429 7.47956 5.4029C7.52388 5.47122 7.58218 5.62407 7.59443 5.83722ZM5.6188 11.302C5.52414 11.4711 5.42752 11.6293 5.32849 11.7788C5.0895 12.1383 4.69864 12.5233 4.49785 12.5233C4.47809 12.5233 4.45418 12.5201 4.41924 12.4833C4.39675 12.4597 4.39314 12.4429 4.39423 12.4198C4.401 12.2876 4.57645 12.0522 4.83062 11.8339C5.06131 11.6359 5.32206 11.4598 5.6188 11.302ZM12.2817 10.3048C12.2511 9.86446 11.5085 9.58197 11.5012 9.57935C11.2142 9.47776 10.9024 9.42841 10.548 9.42841C10.1686 9.42841 9.7596 9.4832 9.23433 9.60571C8.76694 9.27496 8.3632 8.86089 8.06155 8.40249C7.92834 8.19995 7.80859 7.99779 7.7042 7.80031C7.95904 7.19203 8.18852 6.53799 8.14682 5.80546C8.1132 5.2181 7.84788 4.82356 7.48707 4.82356C7.23955 4.82356 7.02645 5.00656 6.85316 5.36799C6.54404 6.01201 6.62529 6.83607 7.09455 7.8194C6.92555 8.21566 6.76853 8.62648 6.61654 9.02416C6.42744 9.51867 6.23259 10.0289 6.01298 10.5142C5.39712 10.7575 4.89118 11.0525 4.46953 11.4146C4.1933 11.6515 3.8603 12.0135 3.84129 12.3915C3.83201 12.5695 3.89316 12.7328 4.0174 12.8636C4.1494 13.0024 4.31523 13.0756 4.49758 13.0758C5.09982 13.0758 5.67944 12.2498 5.7894 12.0841C6.01069 11.7511 6.21783 11.3797 6.42079 10.9512C6.93197 10.7668 7.47674 10.6291 8.00475 10.4961L8.19385 10.4481C8.336 10.412 8.48374 10.3721 8.63528 10.3307C8.79564 10.2875 8.96063 10.2426 9.12832 10.1999C9.67049 10.5442 10.2535 10.7687 10.8222 10.8511C11.3011 10.9206 11.7265 10.8803 12.0144 10.7304C12.2735 10.5957 12.2878 10.3878 12.2817 10.3048ZM13.4481 14.0911C13.4481 14.8975 12.7361 14.9472 12.5925 14.9488H3.40675C2.60188 14.9488 2.55341 14.2332 2.55188 14.0911L2.55177 1.90866C2.55177 1.10146 3.26505 1.05252 3.40664 1.0509H9.61178L9.61508 1.05418V3.47149C9.61508 3.95661 9.90888 4.87509 11.0215 4.87509H13.4274L13.448 4.89567L13.4481 14.0911ZM12.8777 4.3241H11.0219C10.2173 4.3241 10.1686 3.61238 10.1675 3.47156V1.6074L12.8777 4.3241ZM14 14.0911V4.66839L10.1675 0.826633V0.808759H10.1492L9.84138 0.5H3.40677C2.92017 0.5 2 0.794501 2 1.90892V14.0913C2 14.5785 2.29412 15.5 3.40677 15.5H12.5933C13.0798 15.4999 14 15.2054 14 14.0911Z" fill="white" />
        </svg>

      );
    }

    // DEFAULT DOCUMENT ICON
    return (
      <svg width="14" height="16" viewBox="0 0 14 16" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.15783 0C4.96241 0 4.77499 0.0766254 4.63681 0.213011L0.215811 4.57665C0.0776328 4.71304 0 4.89802 0 5.09091V13.8182C0 15.0232 0.989677 16 2.2105 16H11.0525C12.2733 16 13.263 15.0232 13.263 13.8182V2.18182C13.263 0.976836 12.2733 0 11.0525 0H5.15783Z"
          fill="white"
        />
      </svg>
    );
  };


  // Function to get file name from URL
  const getFileName = (url) => {
    return url.split('/').pop();
  };

  // Function to get background color based on file type
  const getIconBgColor = (url) => {
    const extension = url.split('.').pop().toLowerCase();

    if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) {
      return 'bg-orange-500';
    } else if (['pdf'].includes(extension)) {
      return 'bg-red-500';
    } else if (['xls', 'xlsx', 'csv'].includes(extension)) {
      return 'bg-green-500';
    } else {
      return 'bg-orange-500';
    }
  };
console.log(companyData , "companyDatacompanyDatacompanyData");
  return (
    <ToolManagmentCard>
      <h3 className="font-lato not-italic font-semibold text-[16px] leading-[150%] text-[#101828]  mb-3 text-start">Notes & Documents </h3>


      <div className="space-y-6 border-t pt-5">
        {companyData?.notesAndDocuments?.map((item, index) => (
          <div className='p-2 bg-white border border-[#EAECF0] shadow-[0px_1px_3px_rgba(16,24,40,0.1),0px_1px_2px_rgba(16,24,40,0.06)] rounded-xl'>
            <div key={index}>
              {item.documents?.map((docUrl, docIndex) => (
                <div key={docIndex} className="mb-6 last:mb-0 text-start">
                  {/* Document Item */}
                  <div className="flex items-start gap-4">

                    <div className="relative w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0">
                      <div className="absolute inset-0 rounded-full bg-[#FFB76B] opacity-30" />
                      <div className="relative w-8 h-8 rounded-full bg-[#FF8E1C] flex items-center justify-center">
                        {getFileIcon(docUrl)}
                      </div>
                    </div>
                    <div className="flex-1 pt-1">
                      <a
                        href={docUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-lato font-medium text-[14px] leading-[150%] tracking-normal text-[#475467] hover:text-orange-600 block mb-3"

                      >
                        {getFileName(docUrl)}
                      </a>

                      {/* Note Description */}
                      <p className="font-lato font-medium text-[13px] leading-[150%] tracking-normal text-[#101828]">
                        {item.notes}
                      </p>

                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        ))}

        {(!companyData?.notesAndDocuments || companyData.notesAndDocuments.length === 0) && (
          <p className="text-gray-500 text-center py-8">No notes or documents available</p>
        )}
      </div>
    </ToolManagmentCard>

  );
};

export default NoteDocument;